import { AddIcon } from "@chakra-ui/icons";
import {
  Menu, MenuButton, MenuList, MenuItem, Portal, MenuDivider, useDisclosure, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay,
} from "@chakra-ui/react";
import { PlusCirlceButtonWithRef } from "components/Button/PlusCircleButton";
import { useV2PathListQuery } from "features/Path/hooks";
import { Path } from "features/Path/models";
import React, { useCallback } from "react";
import { NewPathForm } from "../Form/PathForm";

interface SelectPathsMenuButtonProps {
  includeCreateNew?: boolean;
  selectedPathIds: string[];
  addPathId: (id: string) => void;
}

export default function SelectPathsMenuButton({ includeCreateNew = true, selectedPathIds, addPathId, ...props }: SelectPathsMenuButtonProps) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const initialRef = React.useRef(null);
  const { data: paths } = useV2PathListQuery("");
  const availablePaths = paths?.filter((path: Path) => !selectedPathIds.includes(path.id)) || [];

  const onPathCreate = useCallback((path: Path) => {
    addPathId(path?.id);
  }, [addPathId]);

  return (
    <>
      <Menu {...props}>
        <MenuButton as={PlusCirlceButtonWithRef} aria-label="Add Path" label="Add Path" />
        <Portal>
          <MenuList overflowY="scroll" maxH="300px">
            { includeCreateNew ? (
              <>
                <MenuItem key="new" onClick={onOpen} icon={<AddIcon />}>Create New Path</MenuItem>
                <MenuDivider />
              </>
            ) : null}
            {availablePaths.length > 0 ? (
              availablePaths.map((path: Path) => (
                <MenuItem key={path.id} onClick={() => addPathId(path.id)}>{path.name}</MenuItem>
              ))
            ) : (
              <MenuItem isDisabled>No available paths</MenuItem>
            )}
          </MenuList>
        </Portal>
      </Menu>
      <Modal initialFocusRef={initialRef} closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose} size="3xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader fontSize={30}>Create & Add To New Path</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <NewPathForm onSuccess={onPathCreate} onClose={onClose} />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
